import { Pipe, PipeTransform } from "@angular/core";

const FULL_HASH_PATTERN = /^[0-9a-f]{40}$/i;
const SHORT_HASH_LENGTH = 7;

@Pipe({
    name: "gitShortHash",
    standalone: true
})
export class GitShortHashPipe implements PipeTransform {
  transform(value: string, length: number = SHORT_HASH_LENGTH): string {
    if (!value || !FULL_HASH_PATTERN.test(value)) {
      return value;
    }
    return value.substring(0, length);
  }
}
